<div [class.blur-sm]="blured">
  <ng-content></ng-content>
</div>
